<div class="not-found">
  <img src="assets/img/not-found.png" alt="" width="300">
  <p>{{'NoDataFound' | translate}}</p>
</div>
